import React from 'react';
export function FinalCTA() {
  return <section className="w-full bg-cream py-20 px-4 flex flex-col items-center text-center border-t border-peach" data-id="element-45">
      <div className="max-w-3xl w-full" data-id="element-46">
        <div className="text-5xl mb-6" data-id="element-47">🌱</div>
        <h2 className="text-3xl md:text-5xl font-bold text-brown-800 mb-6 leading-tight" data-id="element-48">
          ORGANIZAR TUS COMIDAS PUEDE SER MUCHO MÁS SIMPLE
        </h2>

        <p className="text-xl md:text-2xl text-brown-600 mb-10 font-medium" data-id="element-49">
          No necesitás hacerlo perfecto. Necesitás herramientas claras y un
          sistema posible.
        </p>

        <a href="#compra" className="bg-gradient-to-r from-gold-400 to-gold-500 text-white font-bold text-xl md:text-2xl py-5 px-10 rounded-full shadow-xl hover:shadow-2xl transform hover:-translate-y-1 transition-all duration-300 inline-block w-full md:w-auto" data-id="element-50">
          👉 Accedé ahora a FREEZER INTELIGENTE y dejá de decidir todos los días
          qué cocinar.
        </a>
      </div>
    </section>;
}